export enum JobPostingStatus {
    Active = 'active',
    Archived = 'archived',
    Paused = 'paused',
}
